<!--单选 SCQ-->
<template>
  <div class="question-editor">
    <div class="question-pd">
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <span class="question-number">{{ `${index + 1}、` }}</span>
          </div>
          <div class="question-select">
            <span>姓名</span>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>
      <div class="input-container" style="border: 1px solid #dcdde0">
        <input
          type="text"
          placeholder="姓名"
          v-model="caseProblem"
          @input="handleInput"
          @focus="isFocusIndex = '-1'"
          @blur="isFocusIndex = ''"
          class="input-container-input"
        />
      </div>
      <div class="input-container">
        <span class="input-container-text">姓名</span>
      </div>
    </div>
    <div class="must-container">
      <el-checkbox
        label="必选题"
        v-model="isMust"
        :true-label="1"
        :false-label="0"
        class="custom-checkbox"
        @change="handleCheckboxChange"
      ></el-checkbox>
    </div>
    <div v-if="type === 1" class="question-footer">
      <!-- <div class="cancel-btn" @click="cancelClick">取消</div> -->
      <div class="save-btn" @click="saveClick">保存</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 1, // 1 添加问卷 2 添加题库
    },
    updateType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [],
      dataObj: {},
      ifRandomize: false,
      isMust: false,
      uploadIndex: 0,
      images: [],
      caseProblem: "",
      isFocusIndex: "",
      inputFocusIndex: "",
    };
  },
  methods: {
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
    handleInput() {
      this.handleUpdateQuestion();
    },
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdateQuestion();
    },
    handleCheckboxChange() {
      this.handleUpdateQuestion();
    },
    handleUpdateQuestion() {
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblem = this.caseProblem;
      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    saveClick() {
      if (this.caseProblem.includes(" ") && this.caseProblem.trim() === "") {
        this.$message.error("请输入题目");
      }

      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblem =
        this.caseProblem === "" ? "姓名" : this.caseProblem;
      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    handleClick() {},
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        console.log("dataObj 变化了", newVal, oldVal);
        this.dataObj = newVal;
        this.caseProblem = newVal.caseProblem;
        this.isMust = newVal.isMust === 1;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
button {
  margin-left: 10px;
}

.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-batch {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #509dee;
  line-height: 20px;
  cursor: pointer;
}

.minus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input {
  padding: 0 10px;
  background: #ffffff;
}

.plus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.question-header-left {
  display: flex;
  align-items: center;
}

.question-header-right {
  display: flex;
  align-items: center;
}

.option-item-top-right input {
  color: #4c4a56;
}
.textarea-box textarea {
  color: #4c4a56;
}
</style>



// WEBPACK FOOTER //
// src/components/EvaluationEdit/EvaluationEditName.vue